import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from "./auth.service";

@Injectable()
export class AuthGuardService implements CanActivate, CanActivateChild {

    constructor(
        private _authService: AuthService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let url: string = state.url;

        return this.checkLogin(url);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

    checkLogin(url: string): boolean {
        if (this._authService.isLoggedIn) { return true; }

        // Store the attempted URL for redirecting
        this._authService.redirectUrl = url;

        // Navigate to the login page with extras
        this._authService.checkCookie();
        return false;
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/services/auth-guard.service.ts
 **/